import React, { useState } from 'react'

interface AccordionProps {
  children: React.ReactNode
  className?: string
}

interface AccordionItemProps {
  title: string
  children: React.ReactNode
}

export const Accordion: React.FC<AccordionProps> = ({
  children,
  className = ''
}) => {
  return (
    <div className={`border border-gray-200 rounded-lg divide-y divide-gray-200 my-6 ${className}`}>
      {children}
    </div>
  )
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="first:rounded-t-lg last:rounded-b-lg">
      <button
        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <b className={`text-gray-800 ${isOpen ? 'font-bold italic' : 'font-semibold'}`}>{title}</b>
        <svg
          className={`w-5 h-5 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <div className="px-6 pb-2 prose prose-sm max-w-none">
          {children}
        </div>
      )}
    </div>
  )
}